import React, { useEffect, useState } from 'react'
import * as classes from './index.module.css'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import Menu from '@Src/svgs/Menu'
import MenuArrow from '@Src/svgs/MenuArrow'
import XIcon from '@Src/svgs/XIcon'
import { useStore, setNavState } from '@UseCase/store'

const Navigation = ({ location }) => {
	const [store, dispatch] = useStore()
	const { navOpenState } = store
	const [openedSubMenu, setOpenedSubMenu] = useState(null)

	const toggleClass = navOpenState === 'nav' ? classes.navOpend : classes.nav

	const navigation = [
		{
			url: '/about-us',
			title: 'About Us',
		},
		{
			url: '/our-work',
			title: 'Our Work',
		},
		{
			url: '/services',
			title: 'Services',
			subPages: [
				{
					url: '/services/commercial-strategy',
					title: 'Commercial Strategy',
				},
				{
					url: '/services/market-intelligence',
					title: 'MARKET INTELLIGENCE',
				},
				{
					url: '/services/audience-insights',
					title: 'Audience Insights',
				},
				{
					url: '/services/ux-research',
					title: 'UX RESEARCH',
				},
				{
					url: '/services/data-and-analytics',
					title: 'Data & Analytics',
				},
				{
					url: '/services/cultural-insights-and-trends',
					title: 'Cultural Insights & Trends',
				},
				{
					url: '/services/screenthink',
					title: 'Screen Think',
				},
				{
					url: '/services/3reasons',
					title: '3 Reasons',
				},
			],
		},
		{
			url: '/culture-and-career',
			title: 'Culture & Careers',
		},
		{
			url: '/news',
			title: 'NEWS & VIEWS',
		},
		{
			url: '/contact',
			title: 'Contact Us',
		},
	]

	const setState = () => {
		if (navOpenState === 'nav') {
			setNavState(dispatch, '')
			setOpenedSubMenu(null)
		} else {
			setNavState(dispatch, 'nav')
		}
	}

	const toggleSubMenu = (url) => {
		setOpenedSubMenu((current) => (current === url ? null : url))
	}

	useEffect(() => {
		setNavState(dispatch, '')
		setOpenedSubMenu(null)
	}, [location, dispatch])

	return (
		<>
			<button
				className={classes.toggle}
				onClick={setState}
				title="Main menu"
				aria-label="Main menu"
			>
				{navOpenState === 'nav' ? (
					<XIcon className={classes.menuIcon} />
				) : (
					<Menu className={classes.menuIcon} />
				)}
			</button>

			<nav className={toggleClass}>
				<ul className={classes.linksList}>
					{navigation.map((item) => {
						const hasSubPages = item.subPages && item.subPages.length > 0
						const isSubMenuOpen = openedSubMenu === item.url

						return (
							<li
								className={`${classes.navItem} ${
									hasSubPages ? classes.hasSubMenu : ''
								}`}
								key={item.url}
								data-item=""
							>
								<div className={classes.navItemHead}>
									<Link
										to={item.url}
										className={classes.link}
										title={item.title}
										activeClassName={classes.activeLink}
										partiallyActive={item.url !== '/'}
										aria-haspopup={hasSubPages ? 'true' : undefined}
										aria-expanded={hasSubPages ? isSubMenuOpen : undefined}
									>
										{item.title}
									</Link>

									{hasSubPages && (
										<button
											type="button"
											className={classes.subMenuToggle}
											onClick={() => toggleSubMenu(item.url)}
											aria-label={`Toggle ${item.title} submenu`}
											aria-expanded={isSubMenuOpen}
										>
											<MenuArrow
												className={`${classes.menuArrow} ${
													isSubMenuOpen ? classes.menuArrowOpen : ''
												}`}
											/>
										</button>
									)}
								</div>

								{hasSubPages && (
									<ul
										className={`${classes.subMenu} ${
											isSubMenuOpen ? classes.subMenuOpen : classes.subMenuClosed
										}`}
									>
										{item.subPages.map((subItem) => (
											<li className={classes.navSubItem} key={subItem.url}>
												<Link
													to={subItem.url}
													className={classes.subLink}
													title={subItem.title}
													activeClassName={classes.activeSubLink}
												>
													{subItem.title}
												</Link>
											</li>
										))}
									</ul>
								)}
							</li>
						)
					})}
				</ul>
			</nav>
		</>
	)
}

Navigation.propTypes = {
	location: PropTypes.object,
}

export default Navigation